import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-my-file",
  "use": "icon-my-file-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-my-file\"><defs><style type=\"text/css\"></style></defs><path d=\"M261.8 222h520v48.2h-520zM261.8 387h520v48.2h-520zM261.8 546h520v48.2h-520zM261.8 724H551v48.2H261.8z\" fill=\"\" p-id=\"2962\" /><path d=\"M135.2 10.3v999.3h773V10.3h-773z m729 955.4h-685V54.3h685v911.4z\" fill=\"\" p-id=\"2963\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol